// Role Page - Uses generic module initialization patterns
// Demonstrates the streamlined approach for creating module pages

import { createModulePage } from '../../components/generic/createModulePage';
import { initializeModule } from '../../utils/configInit';
import { roleConfig } from './roleConfig';
import { createRoleValidation } from './roleValidation';
// RoleService no longer needed - using SWR hooks directly

/**
 * Initialize the role module using generic utilities
 * This pattern eliminates the need for separate initialization files
 */
const { config: initializedConfig } = initializeModule(
  roleConfig,
  createRoleValidation
);

/**
 * Create the RolePage using the generic module page factory
 * This eliminates the need for custom component wrappers
 */
const RolePage = createModulePage(
  initializedConfig,
  {
    displayName: 'RolePage',
    description: 'Role Management System - Manage user roles and permissions'
  }
);

export default RolePage;
